/* eslint-disable no-shadow */
/* eslint-disable radix */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { MenuItem } from '@material-ui/core';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentsTab from './CommentsTab';
import CommentLinkTab from './CommentLinkTab';
import CommentUserDateInfo from './CommentUserDateInfo';
import CommentAddressInfoTab from './CommentAddressInfoTab';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { commentCorrTableHead } from './gridComponents/tableHead';
import {
  setCommentTab,
  getGeneralSystemParameterDetails,
  getAllCommentCorrList,
  resetUpdateOrSaveMessage,
  postSaveOrUpdate,
  postSingleDeleteComment,
  generateCommentId,
  dispatchSetDisableUpdate
} from '../store/Actions';
import {
  closeTab,
  getCommonDropdownList,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  onCellFocused,
  tabToNextCell,
  navigateToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { isReadOnly as isRead } from '../../../../SharedModules/utilities/utilities';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { EMAIL_ID_REGEX } from '../../../../SharedModules/AppConstants';
import { checkActionAccessByRole, canMutateCommentsByRole } from '../../../../SharedModules/utilities/utilities';

function CommentAndCorrespondenceComponent({ location }) {
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState)?.readOnly || false;
  }

  const dispatch = useDispatch();
  const history = useHistory();
  // dispatch
  const fetchGenerateSeqNum = (value) => {
    return dispatch(generateCommentId(value));
  };
  const deleteSingleComment = (value) => {
    return dispatch(postSingleDeleteComment(value));
  };

  const addEditCommentTab = (value) => {
    return dispatch(setCommentTab(value));
  };
  const fetchAllCommentList = (value) => {
    return dispatch(getAllCommentCorrList(value));
  };
  const resetUpdateOrSaveMessageHandler = (value) =>
    dispatch(resetUpdateOrSaveMessage(value));
  // useSelector
  const commentTabData = useSelector((state) => {
    return state.sharedState.CommentsReducer.commentTabObj;
  });
  const getCorrCommentSeqNumber = useSelector((state) => {
    return state.sharedState.CommentsReducer.generateNewSeqId;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.commentCorrList.sort(
      (a, b) => b.corrCommentId - a.corrCommentId
    );
  });
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.CommentsReducer.saveOrUpdateMessage;
  });
  const deleteMessage = useSelector((state) => {
    return state.sharedState.CommentsReducer.deleteCommentMsg;
  });
  const disableUpdate = useSelector((state) => {
    return state.sharedState.CommentsReducer.disableUpdate;
  });

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.CommentsReducer?.generalSystemParameter
      ?.paramGeneralVO;
  });
  const isSystemParameter =
    generalSystemParameterDetails?.length > 0 &&
    parseInt(generalSystemParameterDetails[0].preventCcUpdateInd) === 1;
  // variable deceleration
  const [editDisabled, setEditDisabled] = useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [canUpdateOrDelete, setCanUpdateOrDelete] = useState(
    canMutateCommentsByRole(kcRoles)
  );
  const gridRef = React.useRef();
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [successMessages, setSuccessMessage] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [tabValue, setTabValue] = useState('one');
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] = useState(false);
  const [commentClick, setCommentClick] = useState(false);
  const [disabledFiled, setDisabledFiled] = useState(true);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [selectRowData, setSelectRowData] = useState({});
  const [defaultRow, setDefaultRow] = useState(true);
  const [showToolTip, setShowToolTip] = useState(true);
  const [deleteRecorded, setDeleteRecorded] = useState(false);
  const [gridParams, setGridParams] = useState('');
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [keyValue, setKeyValue] = React.useState([]);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [selectRowIndex, setSelectRowIndex] = useState(
    commentTabData.selectRowIndex ? commentTabData.selectRowIndex : 0
  );
  const [
    { showSubjectErr, showZip4Err, showPhoneErr, showEmailErr },
    setShowError,
  ] = useState(false);
  const [state, setState] = useState(true);
  
  const delaying = (ms) => {
    new Promise( (resolve) => {
      const start = performance.now();
      const frame = (now) => {
        if(now - start >= ms) {
          resolve();
        } else {
          requestAnimationFrame(frame);
        }
      };
      requestAnimationFrame(frame);
    });
  }

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
      setCanUpdateOrDelete(canMutateCommentsByRole(kcRoles));
    }
  }, [kcRoles]);
  const isNewComment = !commentsList?.some(
    (x) => x.corrCommentId === selectRowData?.corrCommentId
  );
  // Normal users may add new comments but not edit existing ones.
  const canEditSelectedComment = canUpdateOrDelete || isNewComment;
  const isCommentEditDisabled =
    isReadOnly ||
    !isEnablebyRole ||
    !canEditSelectedComment ||
    (isSystemParameter && disabledFiled) ||
    disableUpdate;
  const isCommentDeleteDisabled =
    isReadOnly ||
    !isEnablebyRole ||
    !canUpdateOrDelete ||
    (commentsList &&
      commentsList.length > 0 &&
      commentsList.filter((x) => {
        return x.corrCommentId === selectRowData.corrCommentId;
      }).length === 0) ||
    isSystemParameter ||
    (commentsList && commentsList.length === 0);
  React.useEffect(() => {
    handleScrollToEvent();
    getCommonDropdownList({
      codeDomainList: ['CORR_METHOD_CD', 'CORR_TYPE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    dispatch(getGeneralSystemParameterDetails());
  }, []);
  // handing highlight tab
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (commentTabData && Object.keys(commentTabData).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (
            item.navTo === '/comment' &&
            isEnablebyRole &&
            canEditSelectedComment &&
            (!disabledSaveCancelBtn)
          ) {
            item.isFormDirty = true;
            if (
              commentTabData.errorMessages &&
              commentTabData.errorMessages.length > 0
            ) {
              item.isFormError = true;
            } else {
              item.isFormError = false;
            }
          } else if (item.navTo === '/comment') item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [commentTabData]);
  // handing refresh functionality
  React.useEffect(() => {
    if (commentTabData && Object.keys(commentTabData).length === 0) {
      fetchGenerateSeqNum(null);
      setDisabledSaveCancelBtn(true);
      setSelectRowIndex(0);
      // dispatch(getGeneralSystemParameterDetails());
      fetchAllCommentList({
        corrLinkId: 0,
        linkTableName: null,
      });
    } else {
      const tempObj = commentTabData;
      if (tempObj && tempObj.fullScreenView)
        setFullScreenView(tempObj.fullScreenView);
      if (tempObj && tempObj.disabledSaveCancelBtn)
        setDisabledSaveCancelBtn(tempObj.disabledSaveCancelBtn);
      if (tempObj && tempObj.selectRowData)
        setSelectRowData(tempObj.selectRowData);
      if (tempObj && tempObj.tabValue) setTabValue(tempObj.tabValue);
      if (tempObj && tempObj.defaultRow) setDefaultRow(tempObj.defaultRow);
      if (tempObj && tempObj.disabledFiled !== undefined)
        setDisabledFiled(tempObj.disabledFiled);
      if (tempObj && tempObj.deleteRecorded)
        setDeleteRecorded(tempObj.deleteRecorded);
      if (tempObj && tempObj.selectRowIndex)
        setSelectRowIndex(tempObj.selectRowIndex);
      setShowError({
        showSubjectErr: tempObj && tempObj.showSubjectErr,
        showZip4Err: tempObj && tempObj.showZip4Err,
        showPhoneErr: tempObj && tempObj.showPhoneErr,
        showEmailErr: tempObj && tempObj.showEmailErr,
      });
      setErrorMessages(tempObj && tempObj.errorMessages);
    }
  }, [commentTabData || setDisabledSaveCancelBtn]);
  const onGridReady = (params) => {
    setGridParams(params);
    if (
      isSystemParameter &&
      commentTabData &&
      Object.keys(commentTabData).length === 0
    ) {
      setDisabledFiled(true);
    }
    params.api.forEachNode(
      (node) =>
        node.rowIndex === (selectRowIndex || 0) && node.setSelected(true)
    );
  };
  // set value after click on add new comment or double click on grid row
  const setDefaultSelectData = (data, seqNum, action, val, rowIndex) => {
    setSelectRowData({});
    setSpinnerLoader(false);
    setTabValue('one');
    fetchGenerateSeqNum(null);
    setShowError({
      showSubjectErr: false,
      showZip4Err: false,
      showPhoneErr: false,
      showEmailErr: false,
    });
    setErrorMessages([]);
    const newObj = {
      corrCommentId:
        seqNum || (data && data.corrCommentId ? data.corrCommentId : null),
      crateDate: data && data.crateDate ? data.crateDate : null,
      creatorId: data && data.creatorId ? data.creatorId : null,
      lastUpdateDt: data && data.lastUpdateDt ? data.lastUpdateDt : null,
      lastUpdateUserId: data.userId,
      corrMethodCD:
        data && data.corrMethodCD !== undefined && data.corrMethodCD !== null
          ? data.corrMethodCD
          : '-1',
      corrTypeCD:
        data && data.corrTypeCD !== undefined && data.corrTypeCD !== null
          ? data.corrTypeCD
          : '-1',
      corrDirectionCD:
        data && data.corrDirectionCD ? data.corrDirectionCD : null,
      dispValidResponseInd:
        data && data.dispValidResponseInd ? data.dispValidResponseInd : null,
      sysLetterInd: data && data.sysLetterInd ? data.sysLetterInd : '',
      disputeCorrInd: data && data.disputeCorrInd ? data.disputeCorrInd : null,
      corrName: data && data.corrName ? data.corrName : '',
      addLine1: data && data.addLine1 ? data.addLine1 : '',
      addLine2: data && data.addLine2 ? data.addLine2 : '',
      addLine3: data && data.addLine3 ? data.addLine3 : '',
      city: data && data.city ? data.city : '',
      stateCD: data && data.stateCD ? data.stateCD : '',
      zip: data && data.zip ? data.zip : '',
      zip4: data && data.zip4 ? data.zip4 : '',
      phoneNum: data && data.phoneNum ? data.phoneNum : '',
      phoneExtension: data && data.phoneExtension ? data.phoneExtension : '',
      faxNum: data && data.faxNum ? data.faxNum : '',
      emailAddr: data && data.emailAddr ? data.emailAddr : '',
      corpName: data && data.corpName ? data.corpName : '',
      subject: data && data.subject ? data.subject : '',
      comments: data && data.comments ? data.comments : '',
      corrLinkId: data && data.corrLinkId ? data.corrLinkId : 0,
    };
    setSelectRowData(newObj);
    if (action === 'update' || !val) {
      addEditCommentTab({
        ...commentTabData,
        fullScreenView: fullScreenView,
        showSubjectErr: false,
        disabledSaveCancelBtn: true,
        showZip4Err: false,
        showPhoneErr: false,
        showEmailErr: false,
        errorMessages: [],
        tabValue: 'one',
        selectRowIndex: rowIndex || 0,
        selectRowData: newObj,
      });
    }
  };
  // call create New seq number API
  const handleCreateNewSeqNumber = () => {
    if (
      getCorrCommentSeqNumber === null ||
      getCorrCommentSeqNumber === undefined
    ) {
      setDisabledSaveCancelBtn(true);
      setErrorMessages([]);
      fetchGenerateSeqNum({});
      setTabValue('one');
    }
  };
  // initial value set
  React.useEffect(() => {
    if (commentTabData && Object.keys(commentTabData).length === 0) {
      if (commentsList && commentsList.length > 0) {
        // setDefaultSelectData(commentsList[0], undefined, '', true);
        setDefaultRow(false);
        setDisabledFiled(true);
      } else {
        handleCreateNewSeqNumber();
      }
    } 
  }, [commentsList]);
  // call AddEdit service after show Success Message
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      // setTimeout(() => {
      //   setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      //   setSpinnerLoader(false);
      //   setDisabledFiled(true);
      // }, 1000);
      if (!clickOncloseTabBtn) {
        dispatch(postSaveOrUpdate(null));
        closeTab('/comment', history, dispatch);
      }
      delaying(1000);
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      setSpinnerLoader(false);
      setDisabledFiled(true);
    } else if (saveOrUpdateMessage === 'failed') {
      // setTimeout(() => {
      //   setErrorMessages([constantMessageData.FAILED_MESSAGE_GENERIC]);
      //   addEditCommentTab({});
      //   setSpinnerLoader(false);
      //   setDisabledFiled(true);
      // }, 1000);
      setSuccessMessage([]);
      delaying(1000);
      setErrorMessages([constantMessageData.FAILED_MESSAGE_GENERIC]);
      addEditCommentTab({});
      setSpinnerLoader(false);
      setDisabledFiled(true);
    }
  }, [saveOrUpdateMessage]);
  // click on delete Comment after success message
  React.useEffect(() => {
    if (deleteMessage === 'SUCCESS') {
      setSuccessMessage([]);
    } else if (deleteMessage === 'failed') {
      deleteSingleComment(null);
      delaying(1000)
      // setTimeout(() => {
        setErrorMessages([constantMessageData.FAILED_MESSAGE_GENERIC]);
        setSuccessMessage([]);
      // }, 1000);
    }
  }, [deleteMessage]);
  React.useEffect(() => {
    if (getCorrCommentSeqNumber) {
      setDefaultSelectData({}, getCorrCommentSeqNumber, '', disabledFiled);
      setDisabledSaveCancelBtn(true);
      setTabValue('one');
    }
  }, [getCorrCommentSeqNumber]);
  // click on filter icon after call
  const handleClearFilter = () => {
    if (commentsList && commentsList.length > 0) {
      gridRef.current.clearFilters();
    }
  };
  // check validation on click save button
  const validateRequest = () => {
    const newObj = selectRowData;
    const errorMessagesArray = [];
    let showSubjectErr = false;
    let showZip4Err = false;
    let showPhoneErr = false;
    let showEmailErr = false;
    if (
      newObj.subject === '' ||
      newObj.subject === null ||
      newObj.subject === undefined
    ) {
      showSubjectErr = true;
      errorMessagesArray.push(constantMessageData.COMMENT_SUBJECT);
    }
    if (
      newObj.phoneNum !== '' &&
      newObj.phoneNum !== null &&
      newObj.phoneNum?.length <= 9
    ) {
      errorMessagesArray.push(constantMessageData.PHONE_INVALID_ERROR);
      showPhoneErr = true;
    }
    if (newObj.zip4 !== '' && newObj.zip4 !== null && newObj.zip4.length <= 3) {
      errorMessagesArray.push(constantMessageData.ZIP4_REQUIRED);
      showZip4Err = true;
    }
    if (
      newObj.emailAddr !== '' &&
      newObj.emailAddr !== null &&
      !EMAIL_ID_REGEX.test(newObj.emailAddr)
    ) {
      errorMessagesArray.push(constantMessageData.EMAIL_INVALID);
      showEmailErr = true;
    }
    if (showSubjectErr || showEmailErr || showZip4Err || showPhoneErr) {
      setShowError({
        showSubjectErr,
        showZip4Err,
        showPhoneErr,
        showEmailErr,
      });
      addEditCommentTab({
        ...commentTabData,
        errorMessages: [...new Set(errorMessagesArray)],
        successMessages: [],
        showSubjectErr,
        showZip4Err,
        showPhoneErr,
        showEmailErr,
      });
      setErrorMessages([...new Set(errorMessagesArray)]);
      setSuccessMessage([]);
      return false;
    }
    addEditCommentTab({
      ...commentTabData,
      errorMessages: [],
      successMessages: [],
      showSubjectErr: false,
      showZip4Err: false,
      showPhoneErr: false,
      showEmailErr: false,
    });
    setErrorMessages();
    setSuccessMessage([]);
    return true;
  };
  // call after check all validation
  const onSubmit = (value) => {
    if (isReadOnly || !isEnablebyRole || !canEditSelectedComment) {
      return;
    }
    setClickOncloseTabBtn(value);
    if (validateRequest()) {
      setErrorMessages([]);
      setSuccessMessage([]);
      openSave(value);
    } else {
      handleScrollToEvent();
    }
  };
  // close and confirm popup
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      dispatch(postSaveOrUpdate(null));
    }
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/comment' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/comment' && item.isFormSave) {
          item.isFormSave = false;
          onSubmit(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // delete single comment
  const handleDeleteComment = async (val) => {
    if (isReadOnly || !isEnablebyRole || !canUpdateOrDelete) {
      return;
    }
    setSpinnerLoader(true);
    setDeletePopup(false);
    handleClearFilter();
    const resp = await deleteSingleComment({ corrCommentId: val });
    const result = await dispatch(
      getAllCommentCorrList({
        corrLinkId: 0,
        linkTableName: null,
      })
    );
    deleteSingleComment(null);
    const NewObj =
      result.commentCorrList &&
      result.commentCorrList.length > 0 &&
      result.commentCorrList.sort(
        (a, b) => b.corrCommentId - a.corrCommentId
      )[0];
    if (NewObj && NewObj.length > 0) {
      NewObj.corrMethodCD = NewObj.corrMethodCD ? NewObj.corrMethodCD : '-1';
      NewObj.corrTypeCD = NewObj.corrTypeCD ? NewObj.corrTypeCD : '-1';
    }
    await Promise.resolve().then(() => {
      delaying(1000);
      setSpinnerLoader(false);
      if (result.commentCorrList && result.commentCorrList.length > 0) {
        handleScrollToEvent();
        setDefaultSelectData(NewObj, undefined, 'delete', true);
        setDefaultRow(false);
      } else {
        setSelectRowData({});
        handleCreateNewSeqNumber();
      }
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj1 =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/comment') {
            item.isFormSave = false;
            item.isFormDirty = false;
            item.isFormError = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
      if (result.commentCorrList && result.commentCorrList.length > 0) {
        addEditCommentTab({
          ...commentTabData,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
          errorMessages: [],
          disabledSaveCancelBtn: true,
          disabledFiled: true,
          deleteRecorded: true,
          selectRowData: NewObj,
        });
      } else {
        addEditCommentTab({
          ...commentTabData,
          successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
          errorMessages: [],
          disabledSaveCancelBtn: true,
          disabledFiled: true,
          deleteRecorded: true,
        });
      }
    })
    // setTimeout(() => {
    //   setSpinnerLoader(false);
    //   if (result.commentCorrList && result.commentCorrList.length > 0) {
    //     handleScrollToEvent();
    //     setDefaultSelectData(NewObj, undefined, 'delete', true);
    //     setDefaultRow(false);
    //   } else {
    //     setSelectRowData({});
    //     handleCreateNewSeqNumber();
    //   }
    //   setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
    //   const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    //   const newObj1 =
    //     updateTabs &&
    //     updateTabs.length > 0 &&
    //     updateTabs.map((item) => {
    //       if (item.navTo === '/comment') {
    //         item.isFormSave = false;
    //         item.isFormDirty = false;
    //         item.isFormError = false;
    //       }
    //       return item;
    //     });
    //   localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
    //   if (result.commentCorrList && result.commentCorrList.length > 0) {
    //     addEditCommentTab({
    //       ...commentTabData,
    //       successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
    //       errorMessages: [],
    //       disabledSaveCancelBtn: true,
    //       disabledFiled: true,
    //       deleteRecorded: true,
    //       selectRowData: NewObj,
    //     });
    //   } else {
    //     addEditCommentTab({
    //       ...commentTabData,
    //       successMessages: [constantMessageData.SUCCESSMESSAGE_GENERIC],
    //       errorMessages: [],
    //       disabledSaveCancelBtn: true,
    //       disabledFiled: true,
    //       deleteRecorded: true,
    //     });
    //   }
    // }, 1000);
    if (commentsList && commentsList.length > 0) {
      gridParams.api.forEachNode(
        (node) => node.rowIndex === 0 && node.setSelected(true)
      );
      gridParams.api.setFilterModel(null);
    }
    setDeleteRecorded(true);
    setErrorMessages([]);
    setDisabledFiled(true);
    setSpinnerLoader(false);
    setDisabledSaveCancelBtn(true);
    setErrorMessages([]);
  };

  // save popup
  const openSave = (value) => {
    if (!value) {
      masterDataSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // click on yes button after call
  const masterDataSave = async () => {
    if (isReadOnly || !isEnablebyRole || !canEditSelectedComment) {
      handleSaveClose();
      return;
    }
    handleSaveClose();
    handelCancelClose();
    handleClearFilter();
    const saveRequest = { ...selectRowData };
    saveRequest.dispValidResponseInd = saveRequest.dispValidResponseInd
      ? saveRequest.dispValidResponseInd
      : 0;
    saveRequest.disputeCorrInd = saveRequest.disputeCorrInd
      ? saveRequest.disputeCorrInd
      : 0;
    saveRequest.sysLetterInd = saveRequest.sysLetterInd
      ? saveRequest.sysLetterInd
      : 0;
    saveRequest.corrMethodCD =
      saveRequest.corrMethodCD !== undefined &&
      saveRequest.corrMethodCD !== '-1'
        ? saveRequest.corrMethodCD
        : null;
    saveRequest.corrTypeCD =
      saveRequest.corrTypeCD !== undefined && saveRequest.corrTypeCD !== '-1'
        ? saveRequest.corrTypeCD
        : null;
    saveRequest.crateDate = saveRequest.crateDate
      ? saveRequest.crateDate
      : null;
    saveRequest.lastUpdateDt = saveRequest.lastUpdateDt
      ? saveRequest.lastUpdateDt
      : null;
    saveRequest.corrLinkId = saveRequest.corrLinkId
      ? saveRequest.corrLinkId
      : 0;
    saveRequest.corrCommentId = saveRequest.corrCommentId
      ? saveRequest.corrCommentId
      : null;
    saveRequest.creatorId = saveRequest.creatorId
      ? saveRequest.creatorId
      : UserDefaultValues && UserDefaultValues.userId;
    saveRequest.commentLinkDefTableVOList = [];
    saveRequest.lastUpdateUserId = UserDefaultValues?.userId;
    addEditCommentTab({});
    const resp = await dispatch(postSaveOrUpdate(saveRequest));
    const result = await dispatch(
      getAllCommentCorrList({
        corrLinkId: 0,
        linkTableName: null,
      })
    );
    
    delaying(500);
    // setTimeout(() => {
      if (commentsList && commentsList.length > 0) {
        gridParams.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
        gridParams.api.setFilterModel(null);
      }
    // }, 500);
    resetUpdateOrSaveMessageHandler('');
    if (result.commentCorrList && result.commentCorrList.length > 0) {
      addEditCommentTab({});
      handleScrollToEvent();
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj1 =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/comment') {
            item.isFormSave = false;
            item.isFormDirty = false;
            item.isFormError = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
    } else {
      handleCreateNewSeqNumber();
    }
  };
  const resetAllFields = () => {
    setState(false);
    delaying(1000);
    // setTimeout(() => setState(true), 1000);
    setState(true);
    handleScrollToEvent();
    setErrorMessages([]);
    setSuccessMessage([]);
    handleSaveClose();
    handelCancelClose();
    setTabValue('one');
    setSelectRowIndex(0);
    setDisabledSaveCancelBtn(true);
    resetUpdateOrSaveMessageHandler('');
    addEditCommentTab({});
    setShowError({
      showSubjectErr: false,
      showZip4Err: false,
      showPhoneErr: false,
      showEmailErr: false,
    });
    setDisabledFiled(true);
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/comment') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };
  // cancel popup
  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  // click on full screen icon after call
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    addEditCommentTab({
      ...commentTabData,
      fullScreenView: !fullScreenView,
    });
  };
  const handleOnBlurEventAddrTab = (e, name) => {
    setSuccessMessage([]);
    setDisabledSaveCancelBtn(false);
    const { value } = e.target;
    let showEmailErr = false;
    let showZip4Err = false;
    let showPhoneErr = false;
    const errorMessagesArray =
      errorMessages && errorMessages.length > 0 ? [...errorMessages] : [];
    if (name === 'emailAddr' && value !== '' && !EMAIL_ID_REGEX.test(value)) {
      errorMessagesArray.push(constantMessageData.EMAIL_INVALID);
      showEmailErr = true;
    }
    if (name === 'zip4' && value !== '' && value.length <= 3) {
      errorMessagesArray.push(constantMessageData.ZIP4_REQUIRED);
      showZip4Err = true;
    }
    if (name === 'phoneNum' && value !== '' && value.length <= 9) {
      errorMessagesArray.push(constantMessageData.PHONE_INVALID_ERROR);
      showPhoneErr = true;
    }
    if (showEmailErr || showZip4Err || showPhoneErr) {
      addEditCommentTab(
        commentTabData && Object.keys(commentTabData).length > 0
          ? {
              ...commentTabData,
              errorMessages: [...new Set(errorMessagesArray)],
              showSubjectErr: showSubjectErr,
              showZip4Err: showZip4Err,
              showPhoneErr: showPhoneErr,
              showEmailErr: showEmailErr,
            }
          : {
              errorMessages: [...new Set(errorMessagesArray)],
              showSubjectErr: showSubjectErr,
              showZip4Err: showZip4Err,
              showPhoneErr: showPhoneErr,
              showEmailErr: showEmailErr,
            }
      );
      setErrorMessages([...new Set(errorMessagesArray)]);
      setShowError({
        showSubjectErr: showSubjectErr,
        showZip4Err: showZip4Err,
        showPhoneErr: showPhoneErr,
        showEmailErr: showEmailErr,
      });
    } else {
      const errorData =
        errorMessages && errorMessages.length > 0 ? [...errorMessages] : [];
      if (name === 'emailAddr' && !showEmailErr) {
        const index = errorData.findIndex((x) => {
          return x.includes(constantMessageData.EMAIL_INVALID);
        });
        errorData.splice(index, 1);
      }
      if (name === 'zip4' && !showZip4Err) {
        const index1 = errorData.findIndex((x) => {
          return x.includes(constantMessageData.ZIP4_REQUIRED);
        });
        errorData.splice(index1, 1);
      }
      if (name === 'phoneNum' && !showPhoneErr) {
        const index2 = errorData.findIndex((x) => {
          return x.includes(constantMessageData.PHONE_INVALID_ERROR);
        });
        errorData.splice(index2, 1);
      }
      setErrorMessages([...new Set(errorData)]);
      addEditCommentTab(
        commentTabData && Object.keys(commentTabData).length > 0
          ? {
              ...commentTabData,
              errorMessages: [...new Set(errorData)],
              showSubjectErr: showSubjectErr,
              showZip4Err: showZip4Err,
              showPhoneErr: showPhoneErr,
              showEmailErr: showEmailErr,
            }
          : {
              errorMessages: [...new Set(errorData)],
              showSubjectErr: showSubjectErr,
              showZip4Err: showZip4Err,
              showPhoneErr: showPhoneErr,
              showEmailErr: showEmailErr,
            }
      );
      setShowError({
        showSubjectErr: showSubjectErr,
        showZip4Err: showZip4Err,
        showPhoneErr: showPhoneErr,
        showEmailErr: showEmailErr,
      });
    }
  };
  const handleOnChangeEvent = (e, name) => {
    if (isCommentEditDisabled) {
      return;
    }
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    if (
      name === 'phoneNum' ||
      name === 'zip' ||
      name === 'zip4' ||
      name === 'faxNum' ||
      name === 'phoneExtension'
    ) {
      const onlyNumbs = e.target.value.replace(/[^0-9]/g, '');
      setSelectRowData({ ...selectRowData, [name]: onlyNumbs.trim() });
      addEditCommentTab({
        ...commentTabData,
        successMessages: [],
        disabledSaveCancelBtn: false,
        disabledFiled: disabledFiled,
        selectRowData: { ...selectRowData, [name]: onlyNumbs.trim() },
      });
    } else {
      if (name === 'subject') {
        setShowToolTip(false);
      }
      setSelectRowData({
        ...selectRowData,
        [name]: e.target.value,
      });
      addEditCommentTab(
        commentTabData && Object.keys(commentTabData).length > 0
          ? {
              ...commentTabData,
              successMessages: [],
              disabledSaveCancelBtn: false,
              disabledFiled: disabledFiled,
              selectRowData: {
                ...selectRowData,
                [name]: e.target.value,
              },
            }
          : {
              successMessages: [],
              disabledSaveCancelBtn: false,
              disabledFiled: disabledFiled,
              selectRowData: {
                ...selectRowData,
                [name]: e.target.value,
              },
            }
      );
    }
  };
  // check validation on Blur event
  const handleOnBlurSubject = (e) => {
    setDisabledSaveCancelBtn(false);
    if (e.target.value === '') {
      setShowError({
        showSubjectErr: true,
        showZip4Err: false,
        showPhoneErr: false,
        showEmailErr: false,
      });
      setErrorMessages([...new Set([constantMessageData.COMMENT_SUBJECT])]);
      setSuccessMessage([]);
      addEditCommentTab(
        commentTabData && Object.keys(commentTabData).length > 0
          ? {
              ...commentTabData,
              showSubjectErr: true,
              showZip4Err: false,
              showPhoneErr: false,
              showEmailErr: false,
              disabledFiled: disabledFiled,
              errorMessages: [
                ...new Set([constantMessageData.COMMENT_SUBJECT]),
              ],
            }
          : {
              showSubjectErr: true,
              showZip4Err: false,
              showPhoneErr: false,
              showEmailErr: false,
              disabledFiled: disabledFiled,
              errorMessages: [
                ...new Set([constantMessageData.COMMENT_SUBJECT]),
              ],
            }
      );
    } else {
      setShowToolTip(true);
      setShowError({
        showSubjectErr: false,
        showZip4Err: false,
        showPhoneErr: false,
        showEmailErr: false,
      });
      setErrorMessages([]);
      addEditCommentTab(
        commentTabData && Object.keys(commentTabData).length > 0
          ? {
              ...commentTabData,
              showSubjectErr: false,
              showZip4Err: false,
              showPhoneErr: false,
              showEmailErr: false,
              disabledFiled: disabledFiled,
              errorMessages: [],
            }
          : {
              showSubjectErr: false,
              showZip4Err: false,
              showPhoneErr: false,
              showEmailErr: false,
              errorMessages: [],
              disabledFiled: disabledFiled,
            }
      );
    }
  };

  const handleViewHistory = (gridApi) => {
    // setSpinnerLoader(true);
    const selectedRow = gridApi.getSelectedRows()?.[0]?.corrCommentId;
    setShowViewHistory(true);
    if (selectedRow !== undefined) {
      setKeyValue({ CORR_COMMENT_ID: selectedRow });
    }
  };

  React.useEffect(() => {
    const checkAndSetAttributes = () => {
      const hiddenTextarea = document.querySelector(
        'textarea[aria-hidden="true"]'
      );
      if (hiddenTextarea) {
        hiddenTextarea.setAttribute('id', 'hiddenTextArea');
        // Optionally, you can add an aria-labelledby to link it with a label
        // hiddenTextarea.setAttribute('aria-labelledby', 'hiddenLabel');
        return true;
      }
      return false;
    };
    // Try to set the attributes every 100ms, for up to 1 second
    const intervalId = setInterval(() => {
      if (checkAndSetAttributes()) {
        clearInterval(intervalId); // Stop checking once the element is found
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, []);
  React.useEffect(()=>{
  if(isSystemParameter && gridParams?.api ){
    handleAddComments()
  }else if(!isSystemParameter){
    dispatch(dispatchSetDisableUpdate(false))
  }
  },[isSystemParameter,gridParams])
  React.useEffect(()=>{
  if(commentClick&&isSystemParameter){
    dispatch(dispatchSetDisableUpdate(true))
    setCommentClick(false)
  }
  },[commentClick])
  const handleAddComments = ()=>{
    if (!isEnablebyRole || isReadOnly) {
      return;
    }
    handleCreateNewSeqNumber();
    dispatch(dispatchSetDisableUpdate(false))

    setDisabledFiled(false);
    setDisabledSaveCancelBtn(true);
    addEditCommentTab({
      disabledFiled: false,
      disabledSaveCancelBtn: true,
    });

    if (commentsList.length > 0 && gridParams?.api) {
      gridParams.api.forEachNode((node) => node.setSelected(false));
    }
  }

  return (
    <>
      <div className='tabs-container ' data-testid='comment-correspondence'>
        <div className=''>
          <SaveCancelPopup
            data-testid='savePopup'
            open={open}
            title='Save'
            onConfim={() => {
              masterDataSave();
            }}
            onCancel={() => {
              handleSaveClose();
            }}
          />
          <SaveCancelPopup
            data-testid='cancelPopup'
            open={openCancel}
            title='Cancel'
            onConfim={() => {
              resetAllFields();
            }}
            onCancel={() => {
              handelCancelClose();
            }}
          />
          <SaveCancelPopup
            data-testid='deletePopup'
            open={deletePopup}
            title='Delete'
            moduleName='the selected record'
            onConfim={() => {
              handleDeleteComment(selectRowData && selectRowData.corrCommentId);
            }}
            onCancel={() => {
              setDeletePopup(false);
            }}
          />
          <Spinner load={!state || spinnerLoader} />
          <div className='panel'>
            {!fullScreenView && (
              <>
                <CustomSeparator
                  parent1='System'
                  parent2='Correspondence / Comments'
                />
                <DisplayErrorMessages
                  errorMessages={
                    errorMessages && errorMessages.length > 0
                      ? errorMessages
                      : []
                  }
                />
                <DisplaySuccessMessages successMessages={successMessages} />
              </>
            )}
          </div>
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner common-popup comments-table frr-tbl-with-feature'>
            {state && commentsList && commentsList.length > 0 ? (
              <TableGrid
                ref={gridRef}
                gridHeight={fullScreenView ? '70vh' : 200}
                rowData={commentsList}
                columnDefs={commentCorrTableHead}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridCall={onGridReady}
                exportFile
                helpMessage=''
                data-testid='onEditingStopped'
                fileName='Comment and Correspondence'
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                suppressCellFocus
                onCellFocused={onCellFocused}
                onSelect={(e) => {
                  setCommentClick(true)
                  setDisabledSaveCancelBtn(true);
                  setDisabledFiled(true);
                  setDefaultRow(false);
                  setTabValue('one');
                  setSelectRowIndex(e.rowIndex);
                  fetchGenerateSeqNum(null);
                  setSuccessMessage([]);
                    if(isSystemParameter){
                  setEditDisabled(true);
                  }
                  setErrorMessages([]);
                  setShowError({
                    showSubjectErr: false,
                    showZip4Err: false,
                    showPhoneErr: false,
                    showEmailErr: false,
                  });
                  setDefaultSelectData(
                    e.data,
                    undefined,
                    'update',
                    true,
                    e.rowIndex
                  );
                }}
                frameworkComponents={{
                  subjectRenderEdit: (cellInfo) => {
                    const name = cellInfo.data && cellInfo.data.subject;
                    if (name && name.length > 38) {
                      return (
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='labeler-tooltip'>{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                handleViewHistory={handleViewHistory}
              />
            ) : null}
          </div>
          <div className='row mt-3 '>
            <div className='col-sm-4'>
              <div className='tab-header tab-height'>
                <div style={{ display: 'flex' }}>
                  <div
                    role='button'
                    data-testid='add-commentBtn'
                    className='icon-plus plus-comments'
                    tabIndex='0'
                    onClick={
                      handleAddComments
                    }
                    style={{
                      opacity: !isEnablebyRole ? 0.5 : 1,
                      cursor: !isEnablebyRole ? 'not-allowed' : 'pointer',
                      pointerEvents: !isEnablebyRole ? 'none' : 'auto',

                    }}
                  >
                    <span style={{ position: 'relative', top: '7px' }}>
                      Add Comments
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-sm-8'>
              <div className='tab-header'>
                <div className='float-right hide-on-print btn-wrapper frr-remove-btn-padding'>
                  <Button
                    className='btn btn-success btn-save'
                    data-testid='saveBtn'
                    disabled={disabledSaveCancelBtn || isReadOnly}
                    type='button'
                    onClick={() => {
                      onSubmit(true);
                    }}
                  >
                    {' '}
                    <SVGComponent iconName='Icon-awesome-save' />
                    Save
                  </Button>
                  {deletePopup ? (
                    <Button
                      className='btn btn-success btn-del'
                      data-testid='deleteBtn'
                      type='button'
                      disabled={isCommentDeleteDisabled}
                    >
                      <SVGComponent iconName='Icon-trash' />
                      Delete
                    </Button>
                  ) : (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='labeler-tooltip'>
                          On clicking Delete, the record will be deleted from
                          the DB
                        </Tooltip>
                      }
                    >
                      <Button
                        className='btn btn-success btn-del'
                        onClick={() => {
                          setDeletePopup(true);
                        }}
                        type='button'
                        data-testid='deleteBtn'
                        disabled={isCommentDeleteDisabled}
                      >
                        <SVGComponent iconName='Icon-trash' />
                        Delete
                      </Button>
                    </OverlayTrigger>
                  )}

                  <Button
                    type='button'
                    disabled={
                      disabledSaveCancelBtn ||
                      isReadOnly ||
                      !isEnablebyRole ||
                      !canEditSelectedComment
                    }
                    onClick={() => handleOpenClose()}
                    className='btn btn-cancel'
                    data-testid='cancelBtn'
                  >
                    <SVGComponent iconName='Icon-cancel' />
                    Cancel
                  </Button>
                </div>
                <div className='clearfix' />
                <div className='form-wrapper' />
              </div>
            </div>
          </div>

          <div className='mui-custom-form no-mar gin '>
            <fieldset className='custom-fieldset'>
              <legend className='same-font-family'>Comments</legend>

              <div className='form-wrapper db'>
                <div className='row'>
                  <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          label='Correspondence/Comments ID'
                          id='correspondence-comments'
                          inputProps={{ id: 'correspondence-comments' }}
                          fullWidth
                          disabled
                          placeholder=''
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={selectRowData && selectRowData.corrCommentId}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form input-md override-width-95 d-flex flex-column'>
                        {selectRowData.subject &&
                        selectRowData.subject !== '' &&
                        selectRowData.subject.length > 20 &&
                        showToolTip ? (
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='labeler-tooltip'>
                                {selectRowData.subject}
                              </Tooltip>
                            }
                          >
                            <TextField
                              label='Subject'
                              id='subject-field'
                              data-testid='subject1'
                              className='mandate-fields'
                              required
                              disabled={isCommentEditDisabled}
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                maxLength: 255,
                                id: 'subject-field',
                              }}
                              value={selectRowData && selectRowData.subject}
                              onChange={(e) => {
                                handleOnChangeEvent(e, 'subject');
                              }}
                              onBlur={(e) => {
                                handleOnBlurSubject(e);
                              }}
                            />
                          </OverlayTrigger>
                        ) : (
                          <TextField
                            label='Subject'
                            className='mandate-fields'
                            id='subject'
                            data-testid='subject'
                            required
                            disabled={isCommentEditDisabled}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 255, id: 'subject' }}
                            value={selectRowData && selectRowData.subject}
                            onChange={(e) => {
                              handleOnChangeEvent(e, 'subject');
                            }}
                            onBlur={(e) => {
                              handleOnBlurSubject(e);
                            }}
                            helperText={
                              showSubjectErr &&
                              errorMessages &&
                              errorMessages.length > 0
                                ? constantMessageData.COMMENT_SUBJECT
                                : ''
                            }
                            error={
                              showSubjectErr &&
                              errorMessages &&
                              errorMessages.length > 0
                                ? constantMessageData.COMMENT_SUBJECT
                                : ''
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          label='Correspondence Method'
                          id='corrMethodCD'
                          name='corrMethodCD'
                          data-testid='corr-method'
                          disabled={isCommentEditDisabled}
                          fullWidth
                          select
                          placeholder=''
                          inputProps={{ maxLength: 11, id: 'corrMethodCD' }}
                          InputLabelProps={{ shrink: true }}
                          value={
                            selectRowData && selectRowData.corrMethodCD
                              ? selectRowData.corrMethodCD
                              : '-1'
                          }
                          onChange={(e) => {
                            handleOnChangeEvent(e, 'corrMethodCD');
                          }}
                        >
                          <MenuItem
                            key=''
                            value='-1'
                            className='frr-dropdown-blank-item'
                          />

                          {commonDropdownList?.CORR_METHOD_CD?.length > 0
                            ? commonDropdownList?.CORR_METHOD_CD?.map(
                                (item) => {
                                  return (
                                    <MenuItem
                                      key={
                                        item.codeValueID &&
                                        item.codeValueID.codeValue
                                      }
                                      value={
                                        item.codeValueID &&
                                        item.codeValueID.codeValue
                                      }
                                    >
                                      {`${
                                        item.codeValueID &&
                                        item.codeValueID.codeValue
                                      }-${item.shortDescription}`}
                                    </MenuItem>
                                  );
                                }
                              )
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          label='Correspondence Type'
                          id='correspondence_type'
                          name='corrTypeCD'
                          data-testid='corr-type'
                          disabled={isCommentEditDisabled}
                          fullWidth
                          select
                          placeholder=''
                          inputProps={{
                            maxLength: 11,
                            id: 'correspondence_type',
                          }}
                          InputLabelProps={{ shrink: true }}
                          value={
                            selectRowData && selectRowData.corrTypeCD
                              ? selectRowData.corrTypeCD
                              : '-1'
                          }
                          onChange={(e) => {
                            handleOnChangeEvent(e, 'corrTypeCD');
                          }}
                        >
                          <MenuItem
                            key=''
                            value='-1'
                            className='frr-dropdown-blank-item'
                          />

                          {commonDropdownList &&
                          commonDropdownList.CORR_TYPE_CD &&
                          commonDropdownList?.CORR_TYPE_CD?.length > 0
                            ? commonDropdownList?.CORR_TYPE_CD?.map((item) => {
                                return (
                                  <MenuItem
                                    key={
                                      item.codeValueID &&
                                      item.codeValueID.codeValue
                                    }
                                    value={
                                      item.codeValueID &&
                                      item.codeValueID.codeValue
                                    }
                                  >
                                    {`${
                                      item.codeValueID &&
                                      item.codeValueID.codeValue
                                    }-${item.shortDescription}`}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3'>
                    <legend className='same-font-family mx-0'>
                      Correspondence Direction
                    </legend>
                    <div className='ml-1'>
                      <FormControl>
                        <RadioGroup
                          row
                          data-testid='corr-direction'
                          // aria-labelledby="demo-row-radio-buttons-group-label"
                          name='corrDirectionCD'
                          disabled={isCommentEditDisabled}
                          value={
                            selectRowData &&
                            selectRowData.corrDirectionCD === 'Out'
                              ? 'Out'
                              : 'In'
                          }
                          onChange={(e) => {
                            handleOnChangeEvent(e, 'corrDirectionCD');
                          }}
                        >
                          <FormControlLabel
                            disabled={isCommentEditDisabled}
                            value='In'
                            control={<Radio />}
                            label='In'
                            id='In'
                          />
                          <FormControlLabel
                            disabled={isCommentEditDisabled}
                            value='Out'
                            control={<Radio />}
                            label='Out'
                            id='Out'
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div>
                      <div className='ml-3 pl-0'>
                        <FormControlLabel
                          control={
                            <Checkbox color='primary' name='validResponse' />
                          }
                          data-testid='valid-response'
                          disabled={isCommentEditDisabled}
                          label='Valid Response'
                          checked={
                            !!(
                              selectRowData &&
                              selectRowData.dispValidResponseInd === 1
                            )
                          }
                          value={
                            !!(
                              selectRowData &&
                              selectRowData.dispValidResponseInd === 1
                            )
                          }
                          onClick={(e) => {
                            if (isCommentEditDisabled) {
                            } else {
                              setDisabledSaveCancelBtn(false);
                              setSelectRowData({
                                ...selectRowData,
                                dispValidResponseInd: e.target.checked ? 1 : 0,
                              });
                              addEditCommentTab(
                                commentTabData &&
                                  Object.keys(commentTabData).length > 0
                                  ? {
                                      ...commentTabData,
                                      successMessages: [],
                                      disabledSaveCancelBtn: false,
                                      disabledFiled: disabledFiled,
                                      selectRowData: {
                                        ...selectRowData,
                                        dispValidResponseInd: e.target.checked
                                          ? 1
                                          : 0,
                                      },
                                    }
                                  : {
                                      successMessages: [],
                                      disabledSaveCancelBtn: false,
                                      disabledFiled: disabledFiled,
                                      selectRowData: {
                                        ...selectRowData,
                                        dispValidResponseInd: e.target.checked
                                          ? 1
                                          : 0,
                                      },
                                    }
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-sm-6 col-md-8 col-lg-8 col-xl-9 fieldset-customization pl-auto px-md-auto'>
                    <label className='hide-elm' htmlFor='hiddenTextArea'>
                      Comments
                    </label>
                    <legend className='same-font-family mx-0'>Comments</legend>
                    <FormControl fullWidth>
                      <TextField
                        label='Comments-textarea'
                        id='comments-field-system'
                        className='custom-textarea frr-display-hidden-label'
                        data-testid='comment-textarea'
                        placeholder=''
                        multiline
                        rows={2}
                        rowsMax={10}
                        disabled={
                          isCommentEditDisabled
                        }
                        inputProps={{
                          maxLength: 4000,
                          id: 'comments-field-system',
                          'aria-labelledby': 'comments-field-system-label',
                        }}
                        InputProps={{
                          id: 'comments-field-system',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        aria-labelledby='comments-field-system-label'
                        value={selectRowData && selectRowData.comments}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'comments');
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
            </fieldset>
            <div style={{ marginTop: '10px' }}>
              <CommentsTab
                handleChangeTabValue={(event, newValue) => {
                  setTabValue(newValue);
                  addEditCommentTab(
                    commentTabData && Object.keys(commentTabData).length > 0
                      ? {
                          ...commentTabData,
                          tabValue: newValue,
                          disabledFiled: disabledFiled,
                        }
                      : {
                          tabValue: newValue,
                          disabledFiled: disabledFiled,
                        }
                  );
                }}
                tabValue={tabValue}
                errorMessagesArray={errorMessages}
                addrInfoTabErr={showEmailErr || showZip4Err}
              />
            </div>
            <div className='tabs-body'>
              {tabValue === 'one' && (
                <CommentLinkTab selectRowData={selectRowData} />
              )}
              {tabValue === 'two' && (
                <CommentAddressInfoTab
                  isReadOnly={isReadOnly}
                  data-testid='addressInfo-tab'
                  setSuccessMessage={setSuccessMessage}
                  setErrorMessages={setErrorMessages}
                  setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                  selectRowData={selectRowData}
                  isSystemParameter={isSystemParameter && disabledFiled}
                  isEnablebyRole={isEnablebyRole && canEditSelectedComment}
                  errorMessages={errorMessages}
                  handleOnChangeEvent={handleOnChangeEvent}
                  handleOnBlurEvent={(e, name) => {
                    handleOnBlurEventAddrTab(e, name);
                  }}
                  showEmailErr={showEmailErr}
                  showPhoneErr={showPhoneErr}
                  showZip4Err={
                    !!(
                      errorMessages &&
                      errorMessages.length > 0 &&
                      errorMessages.filter((x) => {
                        return x.includes(constantMessageData.ZIP4_REQUIRED);
                      }).length > 0
                    )
                  }
                />
              )}
              {tabValue === 'three' && (
                <CommentUserDateInfo selectRowData={selectRowData} />
              )}
            </div>
            <div className='float-right hide-on-print btn-wrapper mt-4'>
              <Button
                className='btn btn-success btn-save'
                data-testid='saveBtn1'
                disabled={
                  disabledSaveCancelBtn ||
                  isReadOnly ||
                  !isEnablebyRole ||
                  !canEditSelectedComment
                }
                type='button'
                onClick={() => {
                  onSubmit(true);
                }}
              >
                <SVGComponent iconName='Icon-awesome-save' />
                Save
              </Button>
              {deletePopup ? (
                <Button
                  className='btn btn-success btn-del'
                  data-testid='deleteBtn1'
                  type='button'
                  disabled={isCommentDeleteDisabled}
                >
                  <SVGComponent iconName='Icon-trash' />
                  Delete
                </Button>
              ) : (
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip id='labeler-tooltip'>
                      On clicking Delete, the record will be deleted from the DB
                    </Tooltip>
                  }
                >
                  <Button
                    className='btn btn-success btn-del'
                    onClick={() => {
                      setDeletePopup(true);
                    }}
                    type='button'
                    data-testid='deleteBtn1'
                    disabled={isCommentDeleteDisabled}
                  >
                    <SVGComponent iconName='Icon-trash' />
                    Delete
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          </div>
        </div>
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName='CORR_COMMENT'
            keyValue={keyValue}
            isSpinner
          />
        )}
      </div>
    </>
  );
}
export default CommentAndCorrespondenceComponent;
